import React from "react";

const MobileDevBanner = () => {
  return (
    <div
      className="inner_banner service-banner"
      style={{ backgroundImage: "url(/assets/images/site/mobilebanner.png)" }}
    >
      <div className="wrapper">
        <div className="banner_detail_1">
          <div className="details-ser">
            <h1 id="heading_line">Mobile App Development</h1>
            <h2 id="sub_heading1">
            In today’s mobile-first world, your business needs to be just a tap away. At Codeflix Web LLC, we specialize in creating innovative, user-friendly mobile applications that help businesses connect with their customers and elevate their digital presence.
            </h2>
          </div>
          <div className="arrows">
            <img src="/assets/images/new/arrows-ser.svg" alt="arrows" />
          </div>
          <div className="slider-block">
              <img src="/assets/images/new/sercive_banner.png" alt="" />
            </div>
        </div>
      </div>
    </div>
  );
};

export default MobileDevBanner;
